<script setup>
import { ref, provide } from "vue";
import { useRoute } from "vue-router";

const isModalHidden = ref(false); // controla a visibilidade do modal
provide("isModalHidden", isModalHidden);

//const route = useRoute(); // Obtém a instância de rota atual

function CloseModal() {
  isModalHidden.value = true;
  
}


//const route = useRoute(); // Acessa a instância da rota atual

const route = useRoute(); // Obtém a instância da rota atual
const linkId = route.params.linkId; // Extrai apenas o parâmetro necessário

// defineProps automaticamente disponibiliza linkId no template
// defineProps({
//   linkId: {
//     type: String,
//     required: true,
//   },
// });

</script>

<template>
  <!-- Main modal -->
  <div
    id="crypto-modal"
    tabindex="-1"
    aria-hidden="true"
    :class="[
 { hidden: isModalHidden },
    'fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50'
  ]"
  >
    <div class="relative p-4 w-full max-w-xs ">
      <!-- Modal content -->
      <div class="relative bg-surface rounded-lg shadow ">
        <!-- Modal header -->
        <div
          class="flex items-center justify-between p-4 md:p-5 border-b rounded-t "
        >
          <h3 class="text-lg font-semibold text-gray-900 ">
            Criar {{route.params.linkId}}
          </h3>
          <button
            type="button"
            @click="CloseModal"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center "
            data-modal-toggle="crypto-modal"
          >
            <svg
              class="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>
        <!-- Modal body -->
        <div class="p-4 md:p-5">
          <p class="text-sm font-normal text-gray-500 ">
            Criar uma {{ linkId }} a partir de um texto?
          </p>
          <ul class="my-4 space-y-3">
            <li>
              <span
                class="flex items-center justify-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow text-center"
              >
              
                <span class="flex-1">
                    
                    <router-link
                      to="/TextSelector"
                      class="hover:text-gray-400"
                      >Sim</router-link
                    >
                    

                </span>
              </span>
            </li>
            <li>
              <a
                href="#"
                class="flex items-center justify-center p-3 text-base font-bold text-gray-900 rounded-lg bg-gray-50 hover:bg-gray-100 group hover:shadow text-center"
              >
                <span class="flex-1">
                  <router-link
                      v-if ="linkId === 'Ficha'"
                      to="/FilingCreateModalForm"
                      class="hover:text-gray-400"
                      >Não</router-link
                    >
                    <router-link
                      v-else-if="linkId === 'Citação'"
                      to="/QuoteCreateModalForm"
                      class="hover:text-gray-400"
                      >Não</router-link
                    >
                  </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
